function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/*!
 * Unidragger v3.0.1
 * Draggable base class
 * MIT license
 */

(function (window, factory) {
  // universal module definition
  if (typeof module == 'object' && module.exports) {
    // CommonJS
    module.exports = factory(window, require('ev-emitter'));
  } else {
    // browser global
    window.Unidragger = factory(window, window.EvEmitter);
  }
})(typeof window != 'undefined' ? window : this, function factory(window, EvEmitter) {
  function Unidragger() {}

  // inherit EvEmitter
  var proto = Unidragger.prototype = Object.create(EvEmitter.prototype);

  // ----- bind start ----- //

  // trigger handler methods for events
  proto.handleEvent = function (event) {
    var method = 'on' + event.type;
    if (this[method]) {
      this[method](event);
    }
  };
  var startEvent, activeEvents;
  if ('ontouchstart' in window) {
    // HACK prefer Touch Events as you can preventDefault on touchstart to
    // disable scroll in iOS & mobile Chrome metafizzy/flickity#1177
    startEvent = 'touchstart';
    activeEvents = ['touchmove', 'touchend', 'touchcancel'];
  } else if (window.PointerEvent) {
    // Pointer Events
    startEvent = 'pointerdown';
    activeEvents = ['pointermove', 'pointerup', 'pointercancel'];
  } else {
    // mouse events
    startEvent = 'mousedown';
    activeEvents = ['mousemove', 'mouseup'];
  }

  // prototype so it can be overwriteable by Flickity
  proto.touchActionValue = 'none';
  proto.bindHandles = function () {
    this._bindHandles('addEventListener', this.touchActionValue);
  };
  proto.unbindHandles = function () {
    this._bindHandles('removeEventListener', '');
  };

  /**
   * Add or remove start event
   * @param {String} bindMethod - addEventListener or removeEventListener
   * @param {String} touchAction - value for touch-action CSS property
   */
  proto._bindHandles = function (bindMethod, touchAction) {
    var _this = this;
    this.handles.forEach(function (handle) {
      handle[bindMethod](startEvent, _this);
      handle[bindMethod]('click', _this);
      // touch-action: none to override browser touch gestures. metafizzy/flickity#540
      if (window.PointerEvent) handle.style.touchAction = touchAction;
    });
  };
  proto.bindActivePointerEvents = function () {
    var _this2 = this;
    activeEvents.forEach(function (eventName) {
      window.addEventListener(eventName, _this2);
    });
  };
  proto.unbindActivePointerEvents = function () {
    var _this3 = this;
    activeEvents.forEach(function (eventName) {
      window.removeEventListener(eventName, _this3);
    });
  };

  // ----- event handler helpers ----- //

  // trigger method with matching pointer
  proto.withPointer = function (methodName, event) {
    if (event.pointerId === this.pointerIdentifier) {
      this[methodName](event, event);
    }
  };

  // trigger method with matching touch
  proto.withTouch = function (methodName, event) {
    var touch;
    var _iterator = _createForOfIteratorHelper(event.changedTouches),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var changedTouch = _step.value;
        if (changedTouch.identifier === this.pointerIdentifier) {
          touch = changedTouch;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    if (touch) this[methodName](event, touch);
  };

  // ----- start event ----- //

  proto.onmousedown = function (event) {
    this.pointerDown(event, event);
  };
  proto.ontouchstart = function (event) {
    this.pointerDown(event, event.changedTouches[0]);
  };
  proto.onpointerdown = function (event) {
    this.pointerDown(event, event);
  };

  // nodes that have text fields
  var cursorNodes = ['TEXTAREA', 'INPUT', 'SELECT', 'OPTION'];
  // input types that do not have text fields
  var clickTypes = ['radio', 'checkbox', 'button', 'submit', 'image', 'file'];

  /**
   * any time you set `event, pointer` it refers to:
   * @param {Event} event
   * @param {Event | Touch} pointer
   */
  proto.pointerDown = function (event, pointer) {
    // dismiss multi-touch taps, right clicks, and clicks on text fields
    var isCursorNode = cursorNodes.includes(event.target.nodeName);
    var isClickType = clickTypes.includes(event.target.type);
    var isOkayElement = !isCursorNode || isClickType;
    var isOkay = !this.isPointerDown && !event.button && isOkayElement;
    if (!isOkay) return;
    this.isPointerDown = true;
    // save pointer identifier to match up touch events
    this.pointerIdentifier = pointer.pointerId !== undefined ?
    // pointerId for pointer events, touch.indentifier for touch events
    pointer.pointerId : pointer.identifier;
    // track position for move
    this.pointerDownPointer = {
      pageX: pointer.pageX,
      pageY: pointer.pageY
    };
    this.bindActivePointerEvents();
    this.emitEvent('pointerDown', [event, pointer]);
  };

  // ----- move ----- //

  proto.onmousemove = function (event) {
    this.pointerMove(event, event);
  };
  proto.onpointermove = function (event) {
    this.withPointer('pointerMove', event);
  };
  proto.ontouchmove = function (event) {
    this.withTouch('pointerMove', event);
  };
  proto.pointerMove = function (event, pointer) {
    var moveVector = {
      x: pointer.pageX - this.pointerDownPointer.pageX,
      y: pointer.pageY - this.pointerDownPointer.pageY
    };
    this.emitEvent('pointerMove', [event, pointer, moveVector]);
    // start drag if pointer has moved far enough to start drag
    var isDragStarting = !this.isDragging && this.hasDragStarted(moveVector);
    if (isDragStarting) this.dragStart(event, pointer);
    if (this.isDragging) this.dragMove(event, pointer, moveVector);
  };

  // condition if pointer has moved far enough to start drag
  proto.hasDragStarted = function (moveVector) {
    return Math.abs(moveVector.x) > 3 || Math.abs(moveVector.y) > 3;
  };

  // ----- drag ----- //

  proto.dragStart = function (event, pointer) {
    this.isDragging = true;
    this.isPreventingClicks = true; // set flag to prevent clicks
    this.emitEvent('dragStart', [event, pointer]);
  };
  proto.dragMove = function (event, pointer, moveVector) {
    this.emitEvent('dragMove', [event, pointer, moveVector]);
  };

  // ----- end ----- //

  proto.onmouseup = function (event) {
    this.pointerUp(event, event);
  };
  proto.onpointerup = function (event) {
    this.withPointer('pointerUp', event);
  };
  proto.ontouchend = function (event) {
    this.withTouch('pointerUp', event);
  };
  proto.pointerUp = function (event, pointer) {
    this.pointerDone();
    this.emitEvent('pointerUp', [event, pointer]);
    if (this.isDragging) {
      this.dragEnd(event, pointer);
    } else {
      // pointer didn't move enough for drag to start
      this.staticClick(event, pointer);
    }
  };
  proto.dragEnd = function (event, pointer) {
    var _this4 = this;
    this.isDragging = false; // reset flag
    // re-enable clicking async
    setTimeout(function () {
      return delete _this4.isPreventingClicks;
    });
    this.emitEvent('dragEnd', [event, pointer]);
  };

  // triggered on pointer up & pointer cancel
  proto.pointerDone = function () {
    this.isPointerDown = false;
    delete this.pointerIdentifier;
    this.unbindActivePointerEvents();
    this.emitEvent('pointerDone');
  };

  // ----- cancel ----- //

  proto.onpointercancel = function (event) {
    this.withPointer('pointerCancel', event);
  };
  proto.ontouchcancel = function (event) {
    this.withTouch('pointerCancel', event);
  };
  proto.pointerCancel = function (event, pointer) {
    this.pointerDone();
    this.emitEvent('pointerCancel', [event, pointer]);
  };

  // ----- click ----- //

  // handle all clicks and prevent clicks when dragging
  proto.onclick = function (event) {
    if (this.isPreventingClicks) event.preventDefault();
  };

  // triggered after pointer down & up with no/tiny movement
  proto.staticClick = function (event, pointer) {
    var _this5 = this;
    // ignore emulated mouse up clicks
    var isMouseup = event.type === 'mouseup';
    if (isMouseup && this.isIgnoringMouseUp) return;
    this.emitEvent('staticClick', [event, pointer]);

    // set flag for emulated clicks 300ms after touchend
    if (isMouseup) {
      this.isIgnoringMouseUp = true;
      // reset flag after 400ms
      setTimeout(function () {
        delete _this5.isIgnoringMouseUp;
      }, 400);
    }
  };

  // -----  ----- //

  return Unidragger;
});